import { LicenseInfo } from '@mui/x-license-pro';
import React, { useState } from "react";
import { createBrowserRouter, createRoutesFromElements, Navigate, Route, RouterProvider } from "react-router-dom";
import { FulfillmentStatusContextProvider } from "./Contexts/fulfillmentStatusContext";
import Layout from "./Layout";
import { ForecastReview } from "./Pages/ForecastReview/ForecastReview";
import { FulfillmentStatus } from "./Pages/FulfillmentStatus/FulfillmentStatus";
import ProductSettings from "./Pages/ProductSettings/ProductSettings";
import "./custom.css";
import { ProductSettingsContextProvider } from './Pages/ProductSettings/context/ProductSettingsContext';
import { ForecastReport } from './Pages/ForecastReport/ForecastReport';

LicenseInfo.setLicenseKey('19479ba9cd4b702970e6444ea86462faTz0xMDgyNzYsRT0xNzcxNjMxOTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y');

const router = createBrowserRouter(
    createRoutesFromElements(
        <Route element={<Layout />}>
            <Route path="/forecasting" element={<ForecastReview editableWeeksStartIndex={1} editableWeeksEndIndex={8} startWeek={0} endWeek={13}/>} />
            <Route path="/forecastReport" element={<ForecastReport editableWeeksStartIndex={8} editableWeeksEndIndex={8} startWeek={-8} endWeek={0}/>} />
            <Route path="/fulfillment"
                element={<FulfillmentStatusContextProvider><FulfillmentStatus /></FulfillmentStatusContextProvider>} />
            <Route path="/productSettings/:sku"
                element={<ProductSettingsContextProvider><ProductSettings /></ProductSettingsContextProvider>} />
            <Route path="*" element={<Navigate to="/forecasting" />} />
        </Route>
    ));

export default function App() {
    const [authenticated, setAuthenticated] = useState(false);
    const returnUrl = encodeURIComponent(window.location);

    fetch('login/isauthenticated?ReturnUrl=' + returnUrl).then((response) => {
        if (!response.ok) {
            window.location = 'login?ReturnUrl=' + returnUrl;
        } else {
            setAuthenticated(true)
        }
    });

    if (!authenticated) {
       return null;
    }

    return <RouterProvider router={router} />;
}